function composeFeature(featureName, featureValue) {
    if (featureValue) {
        return `${featureName}:${featureValue}`;
    } else {
        return featureName;
    }
}

function splitFeature(feature) {
    const [name, value] = feature.split(":");
    return [name, value];
}

function joinFeature([featureName, featureValue]) {
    return composeFeature(featureName, featureValue);
}

export function appendToCurrentDebug(featureName, featureValue) {
    const queryParams = new URLSearchParams(document.location.search);
    const value = queryParams.get("debugld");
    if (!value) {
        return composeFeature(featureName, featureValue);
    }

    const features = value.split(",");
    const featureObject = Object.fromEntries(features.map(splitFeature));
    if (featureName in featureObject) {
        featureObject[featureName] = featureValue;
        return Object.entries(featureObject).map(joinFeature).join(",");
    } else {
        const newFeature = composeFeature(featureName, featureValue);
        features.push(newFeature);
        return features.join(",");
    }
}
